import { SearchSortBy } from 'store/search/types';

export const gtmChangeSortingOnSearchPageEvent = (sort: SearchSortBy) => ({
  event: 'sorting-option-change',
  'sorting-option': sort,
});

export default gtmChangeSortingOnSearchPageEvent;
